<template>
  <div
    class="min-h-[500px]"
    @drop="handleDrop"
    @dragover="handleDragOver"
    @dragenter.prevent
    @dragleave="handleDragLeave"
    :class="{
      'bg-blue-50 border-2 border-blue-400 border-dashed rounded-xl':
        isDragOver,
    }"
  >
    <!-- 헤더 -->
    <div class="bg-white border border-gray-200 rounded-lg p-3 mb-4 shadow-sm">
      <div class="font-medium text-gray-800 text-sm">
        {{ typeName }}
      </div>
      <div class="text-xs text-gray-500 mt-1">{{ bonds.length }}개 채권</div>
    </div>

    <!-- 채권 카드들 -->
    <div class="space-y-3">
      <KtbBondCard
        v-for="bond in sortedBonds"
        :key="bond.code"
        :bond="bond"
        :is-dragged="isDraggedBond(bond)"
        @dragstart="$emit('dragstart', $event, bond)"
        @dragend="$emit('dragend')"
        @toggle-benchmark="$emit('toggle-benchmark', bond)"
        @edit="$emit('edit', bond)"
      />

      <!-- 빈 상태 -->
      <div
        v-if="bonds.length === 0"
        class="text-center text-gray-400 text-sm py-12 border-2 border-dashed border-gray-200 rounded-lg bg-gray-50"
        :class="{ 'border-blue-400 bg-blue-50 text-blue-600': isDragOver }"
      >
        <i class="fas fa-plus-circle text-2xl mb-2 opacity-50"></i>
        <div>{{ isDragOver ? '여기에 드롭하세요' : '데이터 없음' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import KtbBondCard from './KtbBondCard.vue';
import { sortBonds } from '@/utils/bondFormatters';
import { computed } from 'vue';

export default {
  name: 'KtbBondColumn',
  components: {
    KtbBondCard,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    typeName: {
      type: String,
      required: true,
    },
    bonds: {
      type: Array,
      default: () => [],
    },
    isDragOver: {
      type: Boolean,
      default: false,
    },
    draggedBond: {
      type: Object,
      default: null,
    },
  },
  emits: [
    'drop',
    'dragover',
    'dragleave',
    'dragstart',
    'dragend',
    'toggle-benchmark',
    'edit',
  ],
  setup(props, { emit }) {
    const sortedBonds = computed(() => sortBonds(props.bonds));

    const isDraggedBond = bond => {
      return props.draggedBond && props.draggedBond.code === bond.code;
    };

    const handleDrop = event => {
      emit('drop', event, props.type);
    };

    const handleDragOver = event => {
      emit('dragover', event, props.type);
    };

    const handleDragLeave = event => {
      emit('dragleave', event);
    };

    return {
      sortedBonds,
      isDraggedBond,
      handleDrop,
      handleDragOver,
      handleDragLeave,
    };
  },
};
</script>
